import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
	LWApiPublicNetworkUtilIsOfficeIpParamsRaw,
	LWApiPublicNetworkUtilIsOfficeIpResultRaw,
} from '@liquidweb-dev/club-sauce/public/network/util/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import apiBasicAuth from 'modules/queries/apiBasicAuth';

export const UTIL_IS_OFFICE_IP_QUERY_KEY = '/util/isOfficeIp';

/**
 * Always uses basic auth as some user types ("kero-only") are restricted from this endpoint for some reason
 */
const useIsOfficeIp = (
	params: LWApiPublicNetworkUtilIsOfficeIpParamsRaw,
	options?: UseQueryOptions<
		LWApiPublicNetworkUtilIsOfficeIpResultRaw,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [UTIL_IS_OFFICE_IP_QUERY_KEY, params],
		queryFn: () => apiBasicAuth.util.apiRaw.isOfficeIp(params),
		...options,
	});

export default useIsOfficeIp;
